import { put, takeLatest } from 'redux-saga/effects';
import {
  EnvironmentSettingActions,
  CodePanelActions,
  OperationsMenuActions,
} from '../../constants';
import { updateDefaultTemplateForEmbeddingType } from '../../utils/templateGenerator';

function saveEnvironmentInfoToLocalStorage(embeddingType, envInfo) {
  if (window.localStorage) {
    localStorage.setItem(`info:${embeddingType}`, JSON.stringify({ env: envInfo }));
  }
}

function* updateEnvironmentInfo(action) {
  saveEnvironmentInfoToLocalStorage(action.embeddingType, action.envInfo);
  const content = yield updateDefaultTemplateForEmbeddingType(action.embeddingType, action.envInfo);
  yield put({ type: CodePanelActions.UPDATE_CONTENT, content, updateLocalContent: true });
}

function* restoreEnvironmentInfo(action) {
  yield put({ type: EnvironmentSettingActions.CLEAR_ENV });
  if (window.localStorage) {
    const envInfo = JSON.parse(localStorage.getItem(`info:${action.embeddingType}`))?.env;
    if (envInfo) {
      yield put({ type: EnvironmentSettingActions.RESTORE_ENV, envInfo });
    }
  }
  yield put({ type: OperationsMenuActions.CHANGE_TYPE, embeddingType: action.embeddingType });
}

export default function* environmentSettingSaga() {
  yield takeLatest(EnvironmentSettingActions.CHANGE_TYPE, restoreEnvironmentInfo);
  yield takeLatest(EnvironmentSettingActions.UPDATE_ENV, updateEnvironmentInfo);
}
